import { definePreset, palette } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const quorumTealPalette = palette('#00A6A6');

export const customThemePreset = definePreset(Aura, {
    semantic: {
        primary: quorumTealPalette as any,
        colorScheme: {
            dark: {
                surface: {
                    0: '#e8ecf4',
                    50: '#d5dae6',
                    100: '#b8c0d1',
                    200: '#9aa4bb',
                    300: '#7d89a5',
                    400: '#636f8f',
                    500: '#4e5976',
                    600: '#3b4460',
                    700: '#2e3550',
                    800: '#232a3e',
                    900: '#1a1f2e',
                    950: '#13161e'
                }
            }
        }
    },
    components: {
        menu: {
            item: {
                padding: `0.125rem 0.75rem`,
            }
        }
    },
    css: ({ dt }: {dt: any}) => `
        .left-nav .p-menu-item-link-active {
            background-color: ${dt('primary.color')};
            color: ${dt('primary.contrast.color')}
        }
        .left-nav .p-menu-separator {
            margin-top: 0.25rem;
        }
    `
});
